var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyReceipt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 431,
    height: 431,
    viewBox: "0 0 431 431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.289 164.277C394.238 164.277 401.493 171.542 401.493 180.505C401.493 189.468 394.238 196.734 385.289 196.734H292.697C301.646 196.734 308.9 204 308.9 212.963C308.9 221.926 301.646 229.192 292.697 229.192H343.622C352.572 229.192 359.826 236.458 359.826 245.421C359.826 254.384 352.572 261.649 343.622 261.649H320.072C308.788 261.649 299.641 268.915 299.641 277.878C299.641 283.854 304.271 289.263 313.53 294.107C322.479 294.107 329.734 301.373 329.734 310.336C329.734 319.299 322.479 326.565 313.53 326.565H121.4C112.451 326.565 105.197 319.299 105.197 310.336C105.197 301.373 112.451 294.107 121.4 294.107H31.1226C22.1736 294.107 14.9189 286.841 14.9189 277.878C14.9189 268.915 22.1736 261.649 31.1226 261.649H123.715C132.664 261.649 139.919 254.384 139.919 245.421C139.919 236.458 132.664 229.192 123.715 229.192H65.8448C56.8958 229.192 49.6411 221.926 49.6411 212.963C49.6411 204 56.8958 196.734 65.8448 196.734H158.437C149.488 196.734 142.234 189.468 142.234 180.505C142.234 171.542 149.488 164.277 158.437 164.277H385.289ZM385.289 229.192C394.238 229.192 401.493 236.458 401.493 245.421C401.493 254.384 394.238 261.649 385.289 261.649C376.34 261.649 369.085 254.384 369.085 245.421C369.085 236.458 376.34 229.192 385.289 229.192Z",
    fill: "#F3F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.928 172.392C150.928 163.889 150.928 159.637 152.583 156.39C154.038 153.533 156.361 151.21 159.218 149.754C162.466 148.1 166.717 148.1 175.22 148.1H236.011C239.255 148.1 240.876 148.1 242.424 148.426C243.797 148.715 245.123 149.193 246.365 149.846C247.764 150.582 249.013 151.617 251.51 153.686L268.156 167.478C271.388 170.156 273.004 171.495 274.165 173.139C275.195 174.596 275.96 176.223 276.425 177.945C276.949 179.888 276.949 181.987 276.949 186.184V266.631C276.949 275.134 276.949 279.386 275.294 282.634C273.839 285.491 271.516 287.813 268.659 289.269C265.411 290.924 261.16 290.924 252.657 290.924H175.22C166.717 290.924 162.466 290.924 159.218 289.269C156.361 287.813 154.038 285.491 152.583 282.634C150.928 279.386 150.928 275.134 150.928 266.631V172.392Z",
    stroke: "#93AFE5",
    strokeWidth: 3.16311,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7.59 6.33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M273.14 302.658L264.119 311.68L291.463 339.025C293.954 341.517 297.993 341.517 300.484 339.025C302.975 336.534 302.975 332.495 300.484 330.004L273.14 302.658Z",
    fill: "#6294F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M276.265 311.198L299.132 334.066",
    stroke: "#CADCFF",
    strokeWidth: 1.17889,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M263.555 290.253L251.715 302.094L264.682 315.062C266.149 316.529 268.527 316.529 269.994 315.062L276.522 308.533C277.989 307.067 277.989 304.689 276.522 303.222L263.555 290.253Z",
    fill: "url(#paint0_linear_2554_33317)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.4496,
    cy: 45.4496,
    r: 45.4496,
    transform: "matrix(-0.707089 0.707124 0.707089 0.707124 233.532 205.906)",
    fill: "#2565DE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0839,
    cy: 35.0839,
    r: 35.0839,
    transform: "matrix(4.21458e-08 1.00003 0.999975 -4.21479e-08 198.615 235.201)",
    fill: "url(#paint1_linear_2554_33317)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M233.185 277.318C232.472 277.318 231.908 277.093 231.495 276.642C231.12 276.154 230.932 275.515 230.932 274.726C230.932 273.562 231.063 272.473 231.326 271.459C231.627 270.407 232.096 269.355 232.735 268.304C233.373 267.252 234.218 266.144 235.27 264.98C236.059 264.079 236.678 263.29 237.129 262.614C237.617 261.9 237.955 261.224 238.143 260.586C238.368 259.947 238.481 259.29 238.481 258.614C238.481 257.374 238.03 256.398 237.129 255.684C236.228 254.971 234.951 254.614 233.298 254.614C231.796 254.614 230.425 254.82 229.185 255.233C227.984 255.609 226.763 256.154 225.523 256.867C224.697 257.356 223.946 257.581 223.27 257.543C222.631 257.468 222.106 257.224 221.692 256.811C221.279 256.398 221.016 255.891 220.904 255.29C220.791 254.689 220.885 254.069 221.185 253.431C221.486 252.792 222.031 252.21 222.819 251.684C224.359 250.67 226.124 249.9 228.115 249.374C230.106 248.811 231.984 248.529 233.749 248.529C236.115 248.529 238.181 248.924 239.946 249.712C241.749 250.501 243.138 251.59 244.115 252.98C245.129 254.37 245.636 256.003 245.636 257.881C245.636 259.046 245.467 260.154 245.129 261.205C244.791 262.219 244.246 263.252 243.495 264.304C242.744 265.318 241.711 266.426 240.397 267.628C239.232 268.679 238.293 269.637 237.58 270.501C236.904 271.365 236.397 272.191 236.059 272.98C235.758 273.769 235.552 274.614 235.439 275.515C235.401 276.041 235.176 276.473 234.763 276.811C234.387 277.149 233.861 277.318 233.185 277.318ZM233.073 289.092C231.796 289.092 230.763 288.698 229.974 287.909C229.223 287.121 228.847 286.107 228.847 284.867C228.847 283.665 229.223 282.689 229.974 281.938C230.763 281.149 231.796 280.754 233.073 280.754C234.387 280.754 235.401 281.149 236.115 281.938C236.866 282.689 237.242 283.665 237.242 284.867C237.242 286.107 236.866 287.121 236.115 287.909C235.401 288.698 234.387 289.092 233.073 289.092Z",
    fill: "#1F64E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.381 117.696L135.931 139.246",
    stroke: "#6B98EC",
    strokeWidth: 1.65769,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.777 145.877L133.247 146.512",
    stroke: "#6B98EC",
    strokeWidth: 1.65769,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.589 104.435L142.583 134.499",
    stroke: "#6B98EC",
    strokeWidth: 1.65769,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2554_33317",
    x1: 257.635,
    y1: 296.174,
    x2: 273.259,
    y2: 311.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F64E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2554_33317",
    x1: 35.0839,
    y1: 0,
    x2: 35.0839,
    y2: 70.1678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyReceipt);
export default __webpack_public_path__ + "static/media/empty-receipt.91bca493c25cb38a011d3b2add40f2e0.svg";
export { ForwardRef as ReactComponent };